<template>
  <div>

    <b-card no-body >
      <b-row class="m-1">
        <b-col lg="3">
          <b-form-group
              label="."
              label-for="fecha_inicio"
          >
            <b-button
              variant="gradient-primary"
              size="md"
              class="mr-1"
              @click="traerPreciosComercial"
              v-b-tooltip.hover="'Recargar'"
            >
              <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
            </b-button>
            <b-button
              variant="gradient-primary"
              size="md"
              @click="mostrarNuevo(true)"
              class="mr-1"
              v-b-tooltip.hover="'Crear Registro'"
              >
              <font-awesome-icon icon="fa-solid fa-plus"/>
            </b-button>
            <b-button
            variant="gradient-primary"
            size="md"
            class="mr-1"
            @click="mostrarModalImportar(true)"
            v-b-tooltip.hover="'Importar Registros'"
            >
              <font-awesome-icon icon="fa-solid fa-file-excel"/>
            </b-button>
          </b-form-group>
        </b-col>
        <b-col lg="3"></b-col>
        <b-col lg="3">
          <b-form-group
            label="Cultivo"
            label-for="cultivos_mostrar"
          >
            <validation-provider
              #default="{ errors }"
              name="cultivos_mostrar"
              vid="cultivos_mostrar"
            >
              <v-select
                id="cultivos_mostrar"
                v-model="cultivos_mostrar"
                :options="cultivos"
                @input="actualizarTabla()"
                placeholder="Seleccionar cultivo"
                multiple
              >
                <span slot="no-options">No se encontraron datos.</span>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group
            label="Búsqueda"
            label-for="evento"
          >
            <b-input-group size="md">
                <b-form-input
                  id="evento"
                  v-model="evento"
                  name="evento"
                />
                <b-input-group-append>
                  <b-button
                      variant="gradient-secondary"
                      :disabled="!evento"
                      @click="itemsFiltro = items; evento = ''"
                  >
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
          </b-form-group>
        </b-col>
        <!-- <b-col lg="2">
          <b-form-group
              label="."
              label-for="fecha_inicio"
          >
            <b-button
                variant="gradient-primary"
                id="btn_back"
                @click="mostrarModalImportar(true)"
                block
            >
              <b class="font-medium-1">Importar Excel &emsp;</b>
            </b-button>
          </b-form-group>
        </b-col> -->
      </b-row>
      <b-table
          hover
          responsive
          class="position-relative"

          :per-page="perPage"
          :current-page="currentPage"

          :items="items"
          :fields="fields"
          :filter="evento"
          :filter-included-fields="filterOn"

          @filtered="cPaginacion"

          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(case)="data">
          <b-badge variant="success">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(acciones)="data">
            <div class="text-nowrap">
              <feather-icon
                  :id="`btn_${data.item.id}_editar`"
                  icon="EditIcon"
                  size="16"
                  class="mr-1"
                  @click="abrirModalEditar(data.item)"
              />
              <b-tooltip
                  title="Editar registro"
                  :target="`btn_${data.item.id}_editar`"
              />
            </div>
          </template>
<!--
        <template #cell(pdf)="data">
          <div class="text-nowrap">
            <feather-icon
                :id="`btn_${data.item.factura}_editar`"
                size="16"
                class="mx-1"
                @click="generarPdf(data.item)"
                v-b-tooltip.hover="'Descargar PDF'"
            />
          </div>
        </template> -->

        <!-- <template #cell(firma)="data">
          <div class="text-nowrap">
            <feather-icon
                :id="`btn_${data.item.id}_ver`"
                icon="ImageIcon"
                size="16"
                class="text-info mx-1"
                @click="verFirma(data.item.firma)"
            />
          </div>
        </template> -->


        <template #cell(pdf)="data">
          <div class="text-nowrap" >
            <b-img
                v-b-tooltip.hover
                title="Descargar PDF"
                :src="require('@/assets/images/icons/pdf1.png')"
                height="auto"
                width="30"
                @click="generarPdf(data.item)"
            />

          </div>
        </template>
        <template #cell(con_evaluador)="data">
          <span class="text-nowrap">{{data.value.nombres}} {{data.value.apellidos}}</span>
        </template>
        <template #cell(emision)="data">
        <span class="text-nowrap">
          {{
            new Date(data.value.split('-')).toLocaleString('pe-PE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              localeMatcher: 'best fit',
              timeZone: 'America/Lima'
            })
          }}
        </span>
        </template>
        <template #cell(modified)="data">
          <span class="text-nowrap">
            {{
              new Date(data.value.split('/')).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                localeMatcher: 'best fit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
        </template>
        <template #cell(estado)="data">
          <b-badge variant="success">
            {{ data.value }}
          </b-badge>
        </template>

      </b-table>
    </b-card>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
        />

      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>

    <b-modal
        id="modal-respuesta"
        ref="modal-respuesta"
        v-model="mostrarErrores"
        title="Errores en el registro"
        ok-title="Aceptar"
        ok-only
        size="md"
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        scrollable
    >
      <b-row>
        <b-col lg="12">
          <!-- <span>Se realizaron la creación de {{ respuestaRegistrosTotal }} registros satisfactoriamente.</span><br><br>
          <span>Se encontraron {{ respuestaErrores.length }} registros con errores:</span><br><br> -->
          <span>Las siguientes filas no se pudieron registrar:</span>
          <div
              v-for="error in respuestaErrores"
              :key="error.contador2"
          >
            <div class="mb-1">
              <br>
              <span>Hoja: {{ error.hoja }}</span><br>
              <span>Fila: {{ error.fila }}</span><br>
              <span>Semana: {{ error.semana }}</span><br>
              <span>Transporte: {{ error.transporte }}</span><br>
              <span>Cod. Cliente: {{ error.cod_cliente }}</span><br>
              <span>Cliente: {{ error.cliente }}</span><br>
              <span>Pack Style: {{ error.pack_style }}</span><br>
            </div>
          </div>


        </b-col>
      </b-row>
    </b-modal>

    <b-modal
        id="modal-importar"
        ref="modal-importar"
        v-model="estadoModalImportar"
        title="Importar Datos Masivos"
        ok-title="Importar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="md"
        :cancel-disabled="loadingIMP"
        :ok-disabled="loadingIMP||!archivo_excel"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @ok="importarOk"
    >
      <div v-if="loadingIMP"  align="center">
        <p>Importando datos ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioImportar" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="enviarFile">
          <b-row>
            <!--
            <b-col lg="12">
              <b-form-group
                  label="Cultivo"
                  label-for="cultivo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Cultivo"
                    vid="cultivo"
                    rules="required"
                >
                  <v-select
                      id="cultivo"
                      v-model="cultivoIMP"
                      :options="cultivosIMP"
                      placeholder="Seleccionar cultivo..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            -->
            <b-col lg="12">
              <b-form-group
                  label="Archivo"
                  label-for="archivo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Archivo"
                    vid="archivo"
                    rules="required"
                >
                  <b-form-file
                      id="archivo"
                      accept=".xlsx"
                      placeholder="Seleccionar Archivo Excel (.xlsx)"
                      v-model="archivo_excel"
                      ref="fileinput"
                  >
                    <template
                        slot="file-name"
                        slot-scope="{ names }"
                    >
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <!-- MODAL NUEVO REGISTRO -->
    <b-modal
      id="modal-nuevo"
      ref="modal-nuevo"
      v-model="mostrarModalNuevo"
      no-close-on-esc
      no-close-on-backdrop
      cancel-variant="secondary"
      ok-title="Registrar"
      cancel-title="Cancelar"
      :cancel-disabled="loadingEditar"
      :ok-disabled="loadingEditar"
      size="lg"
      centered
      title="Nuevo Registro"
      @ok="okModalNuevo"
      @show="resetModal"
      @hidden="resetModal"
    >
      <div v-if="loadingRegistrar"  align="center">
        <p>Editando registro ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <div v-else>
        <validation-observer ref="editarCategoria">
          <b-form autocomplete="off" @submit.prevent="nuevoRegistro">
            <br>
            <br>
            <b-row>

              <b-col lg="4">
                <b-form-group
                    label="SEMANA"
                    label-for="semana_n"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="semana_n"
                      vid="semana_n"
                  >
                    <!-- <b-form-input
                        id="semana_n"
                        name="semana_n"
                        v-model="semana_n"
                        :state="errors.length > 0 ? false:null"

                    /> -->
                    <v-select
                        id="semana_n"
                        v-model="semana_n"
                        :options="semanas"
                        placeholder="Seleccionar semana"
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="TRANSPORTE"
                    label-for="transporte_n"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="transporte_n"
                      vid="transporte_n"
                      rules="required"
                  >
                    <b-form-input
                        id="transporte_n"
                        name="transporte_n"
                        v-model="transporte_n"
                        :state="errors.length > 0 ? false:null"

                    />
                    <!-- <v-select
                        id="transporte_n"
                        v-model="transporte_n"
                        :options="transportes"
                        placeholder="Seleccionar transporte"
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="CULTIVO"
                    label-for="cultivo_n"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Cultivo"
                      vid="cultivo_n"
                      rules="required"
                  >
                    <v-select
                        id="cultivo_n"
                        v-model="cultivo_n"
                        :options="cultivos"
                        placeholder="Seleccionar cultivo"
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  label="INCOTERM"
                  label-for="incoterm_n"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="incoterm_n"
                    vid="incoterm_n"
                    rules="required"
                  >
                    <b-form-input
                      id="incoterm_n"
                      name="incoterm_n"
                      v-model="incoterm_n"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="CODIGO CLIENTE"
                    label-for="cod_cliente_n"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="cod_cliente_n"
                      vid="cod_cliente_n"
                      rules="required"
                  >
                    <b-form-input
                        id="cod_cliente_n"
                        name="cod_cliente_n"
                        v-model="cod_cliente_n"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="CLIENTE"
                    label-for="cliente_n"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="cliente_n"
                      vid="cliente_n"
                      rules="required"
                  >
                    <b-form-input
                        id="cliente_n"
                        name="cliente_n"
                        v-model="cliente_n"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="PACK STYLE"
                    label-for="pack_style_n"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="pack_style_n"
                      vid="pack_style_n"
                      rules="required"
                  >
                    <b-form-input
                        id="pack_style_n"
                        name="pack_style_n"
                        v-model="pack_style_n"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="REFERENCIA"
                    label-for="referencia_n"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="referencia_n"
                      vid="referencia_n"
                      rules="required"
                  >
                    <b-form-input
                        id="referencia_n"
                        name="referencia_n"
                        v-model="referencia_n"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="PUERTO DE DESTINO"
                    label-for="puerto_destino_n"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="puerto_destino_n"
                      vid="puerto_destino_n"
                      rules="required"
                  >
                    <b-form-input
                        id="puerto_destino_n"
                        name="puerto_destino_n"
                        v-model="puerto_destino_n"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4" v-if="cultivo_n=='UVA' || cultivo_n=='ARANDANO'">
                <b-form-group
                    label="VARIEDAD"
                    label-for="variedad_n"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="variedad_n"
                      vid="variedad_n"
                      rules="required"
                  >
                    <b-form-input
                        id="variedad_n"
                        name="variedad_n"
                        v-model="variedad_n"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4" v-if="cultivo_n=='ESPARRAGO'">
                <b-form-group
                    label="CALIBRE"
                    label-for="calibre_n"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="calibre_n"
                      vid="calibre_n"
                      rules="required"
                  >
                    <b-form-input
                        id="calibre_n"
                        name="calibre_n"
                        v-model="calibre_n"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="PRECIO"
                    label-for="precio_n"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="precio_n"
                      vid="precio_n"
                      rules="required"
                  >
                    <b-form-input
                        id="precio_n"
                        name="precio_n"
                        v-model="precio_n"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- <b-col lg="12"  v-for="(x,index) in detalle_des_productos" :key="index">
                CANTIDAD: {{x['cantidad_entregada_final'] }}&nbsp;&nbsp; - &nbsp;&nbsp; DETALLE: {{ x['denominacion_tipo_unidad'] }} {{ x['denominacion_tipo_caja'] }} {{ x['peso_neto_unitario'] }} KG
                {{ x['cultivo'] }} {{ x['denominacion_tipo_fruta'] }}

                <div :id="'detalle_producto'+(index+1)" style="display: none;">{{ x['denominacion_tipo_unidad'] }} {{ x['denominacion_tipo_caja'] }} {{ x['peso_neto_unitario'] }} KG
                {{ x['cultivo'] }} {{ x['denominacion_tipo_fruta'] }} </div>
                <div :id="'cantidad_por_detalles'+(index+1)" style="display: none;">{{ x['cantidad_entregada_final'] }}</div>
                <div :id="'precio_neto_unitario'+(index+1)" style="display: none;">{{ x['precio_neto_unitario'] }}</div>

                <b-form-group
                    :label="'Valor Unitario '+(index+1)"
                    :label-for="'valor_unitario'+(index+1)"
                >
                  <validation-provider
                      #default="{ errors }"
                      :name="'valor_unitario'+(index+1)"
                      :vid="'valor_unitario'+(index+1)"
                      rules="required"
                  >
                    <b-form-input
                        :id="'valor_unitario'+(index+1)"
                        :name="'valor_unitario'+(index+1)"
                        :v-model="'valor_unitario'+(index+1)"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col> -->
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </b-modal>

    <!-- MODAL EDITAR REGISTRO -->
    <b-modal
      id="modal-editar"
      ref="modal-editar"
      v-model="mostrarModalEditar"
      no-close-on-esc
      no-close-on-backdrop
      cancel-variant="secondary"
      ok-title="Editar"
      cancel-title="Cancelar"
      :cancel-disabled="loadingEditar"
      :ok-disabled="loadingEditar"
      size="lg"
      centered
      title="Editar Registro"
      @ok="okModalEditar"
    >
      <div v-if="loadingRegistrar"  align="center">
        <p>Editando registro ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <div v-else>
        <validation-observer ref="editarCategoria">
          <b-form autocomplete="off" @submit.prevent="editarRegistro">
            INFORMACIÓN
            <br>
            <br>
            <b-row>
              <b-col lg="4" hidden>
                <b-form-group
                    label="ID"
                    label-for="id"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="id"
                      vid="id"
                      rules="required"
                  >
                    <b-form-input
                        id="id"
                        name="id"
                        v-model="id"
                        :state="errors.length > 0 ? false:null"
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- <b-col lg="4">
                <b-form-group
                    label="SEMANA"
                    label-for="semana"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="semana"
                      vid="semana"
                      rules="required"
                  >
                    <b-form-input
                        id="semana"
                        name="semana"
                        v-model="semana"
                        :state="errors.length > 0 ? false:null"
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col> -->

              <b-col lg="4">
                <b-form-group
                    label="SEMANA"
                    label-for="semana"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="semana"
                      vid="semana"
                  >
                    <v-select
                        id="semana"
                        v-model="semana"
                        :options="semanas"
                        placeholder="-Seleccionar semana-"
                        disabled
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="TRANSPORTE"
                    label-for="transporte"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="transporte"
                      vid="transporte"
                      rules="required"
                  >
                    <b-form-input
                      id="transporte"
                      name="transporte"
                      v-model="transporte"
                      :state="errors.length > 0 ? false:null"
                    />
                    <!-- <v-select
                        id="transporte"
                        v-model="transporte"
                        :options="transportes"
                        placeholder="-Seleccionar semana-"
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="CULTIVO"
                    label-for="cultivo"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Cultivo"
                      vid="cultivo"
                      rules="required"
                  >
                    <v-select
                        id="cultivo"
                        v-model="cultivo"
                        :options="cultivos"
                        placeholder="-Seleccionar cultivo-"
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                  label="INCOTERM"
                  label-for="incoterm"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="incoterm"
                    vid="incoterm"
                    rules="required"
                  >
                    <b-form-input
                      id="incoterm"
                      name="incoterm"
                      v-model="incoterm"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="CODIGO CLIENTE"
                    label-for="cod_cliente"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="cod_cliente"
                      vid="cod_cliente"
                      rules="required"
                  >
                    <b-form-input
                        id="cod_cliente"
                        name="cod_cliente"
                        v-model="cod_cliente"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="CLIENTE"
                    label-for="cliente"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="cliente"
                      vid="cliente"
                      rules="required"
                  >
                    <b-form-input
                        id="cliente"
                        name="cliente"
                        v-model="cliente"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="PACK STYLE"
                    label-for="pack_style"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="pack_style"
                      vid="pack_style"
                      rules="required"
                  >
                    <b-form-input
                        id="pack_style"
                        name="pack_style"
                        v-model="pack_style"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="REFERENCIA"
                    label-for="referencia"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="referencia"
                      vid="referencia"
                      rules="required"
                  >
                    <b-form-input
                        id="referencia"
                        name="referencia"
                        v-model="referencia"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="PUERTO DE DESTINO"
                    label-for="puerto_destino"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="puerto_destino"
                      vid="puerto_destino"
                      rules="required"
                  >
                    <b-form-input
                        id="puerto_destino"
                        name="puerto_destino"
                        v-model="puerto_destino"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4" v-if="cultivo=='UVA' || cultivo=='ARANDANO'">
                <b-form-group
                    label="VARIEDAD"
                    label-for="variedad"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="variedad"
                      vid="variedad"
                      rules="required"
                  >
                    <b-form-input
                        id="variedad"
                        name="variedad"
                        v-model="variedad"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4" v-if="cultivo=='ESPARRAGO'">
                <b-form-group
                    label="CALIBRE"
                    label-for="variedad"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="calibre"
                      vid="calibre"
                      rules="required"
                  >
                    <b-form-input
                        id="calibre"
                        name="calibre"
                        v-model="calibre"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="PRECIO"
                    label-for="precio"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="precio"
                      vid="precio"
                      rules="required"
                  >
                    <b-form-input
                        id="precio"
                        name="precio"
                        v-model="precio"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>


              <b-col lg="4">
                <b-form-group
                    label="ESTADO"
                    label-for="estado"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="estado"
                      vid="estado"
                      rules="required"
                  >
                    <v-select
                      id="estado"
                      v-model="estadoSelected"
                      :options="estados"
                      :reduce="estados => estados.value"
                      label="text"
                      key="value"
                      placeholder="Seleccionar estado"
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- <b-col lg="12"  v-for="(x,index) in detalle_des_productos" :key="index">
                CANTIDAD: {{x['cantidad_entregada_final'] }}&nbsp;&nbsp; - &nbsp;&nbsp; DETALLE: {{ x['denominacion_tipo_unidad'] }} {{ x['denominacion_tipo_caja'] }} {{ x['peso_neto_unitario'] }} KG
                {{ x['cultivo'] }} {{ x['denominacion_tipo_fruta'] }}

                <div :id="'detalle_producto'+(index+1)" style="display: none;">{{ x['denominacion_tipo_unidad'] }} {{ x['denominacion_tipo_caja'] }} {{ x['peso_neto_unitario'] }} KG
                {{ x['cultivo'] }} {{ x['denominacion_tipo_fruta'] }} </div>
                <div :id="'cantidad_por_detalles'+(index+1)" style="display: none;">{{ x['cantidad_entregada_final'] }}</div>
                <div :id="'precio_neto_unitario'+(index+1)" style="display: none;">{{ x['precio_neto_unitario'] }}</div>

                <b-form-group
                    :label="'Valor Unitario '+(index+1)"
                    :label-for="'valor_unitario'+(index+1)"
                >
                  <validation-provider
                      #default="{ errors }"
                      :name="'valor_unitario'+(index+1)"
                      :vid="'valor_unitario'+(index+1)"
                      rules="required"
                  >
                    <b-form-input
                        :id="'valor_unitario'+(index+1)"
                        :name="'valor_unitario'+(index+1)"
                        :v-model="'valor_unitario'+(index+1)"
                        :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col> -->
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </b-modal>
  </div>
</template>

<script>

import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import { BFormDatepicker,
          BBadge,
          BImg,
          BButton,
          BCard,
          BCardBody,
          BForm,
          BFormGroup,
          BFormInput,
          BFormSelect,
          BModal,
          BFormFile,
          BPagination,
          BSpinner,
          BTable,
          BRow,
          BCol,
          BDropdownDivider,
          BTooltip,
          VBTooltip,
          BInputGroupAppend,
          BInputGroup,
        } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

let digitos_fecha = { year: 'numeric', month: '2-digit', day: '2-digit' };
let fecha_hoy=new Date()

//Formateo fecha_hoy
let fecha_actual = fecha_hoy.toLocaleDateString('es-ES', digitos_fecha).split('/')
fecha_actual=fecha_actual[2]+'-'+fecha_actual[1]+'-'+fecha_actual[0]
//Resto los días a la fecha actual
let dias_a_restar = 6;
fecha_hoy.setDate(fecha_hoy.getDate() - dias_a_restar);
let fecha_desde=fecha_hoy.toLocaleDateString('es-ES', digitos_fecha).split('/')
fecha_desde=fecha_desde[2]+'-'+fecha_desde[1]+'-'+fecha_desde[0]


//OBTENGO EL NUMERO DE SEMANA ACTUAL:

var fechaActual = new Date();
// Crear un objeto de fecha basado en el primer día del año actual
var inicioAnio = new Date(fechaActual.getFullYear(), 0, 1);

// Calcular la diferencia en milisegundos entre la fecha actual y el primer día del año
var diferencia = fechaActual - inicioAnio;

// Convertir la diferencia en semanas
var numeroSemanaActual = Math.ceil(diferencia / (7 * 24 * 60 * 60 * 1000));
var numeroSemanaLimite = numeroSemanaActual + 2


//Obtengo el Codigo del cliente
var id_usuario=localStorage.getItem(['userData'])
id_usuario=JSON.parse(id_usuario)
id_usuario=id_usuario['id']


export default {
  components: {
    BFormDatepicker,
    BCard,
    BImg,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormInput,
    BModal,
    BForm,
    BCol,
    BRow,
    BFormFile,
    BDropdownDivider,
    BTooltip,
    BInputGroupAppend,
    BInputGroup,

  vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data: () => ({
    // fecha_inicio: '2023-01-01',
    id_user: JSON.parse(localStorage.getItem('userData')).id,
    cargandoETL:'',
    fecha_inicio:'2023-01-01',
    fecha_fin: fecha_actual,
    evento: null,
    loading: false,
    numero_semana_actual:numeroSemanaActual,
    numero_semana_limite:numeroSemanaLimite,
    mostrarModalNuevo:false,
    mostrarModalEditar: false,
    loading2: false,
    loadingRegistrar: false,
    valor_unitario:'',
    items: [],
    perPage: 10,
    pageOptions: [10, 15, 20],
    totalRows: 0,
    currentPage: 1,
    filter: null,
    semana_n:'',
    transporte_n:'',
    incoterm_n:'',
    cultivo:'',
    cultivo_n:'',
    cod_cliente_n:'',
    cliente_n:'',
    pack_style_n:'',
    puerto_destino:'',
    puerto_destino_n:'',
    referencia:'',
    referencia_n:'',
    estadoSelected:'',
    variedad_n:'',
    calibre_n:'',
    precio_n:'',
    cultivos_mostrar:[],
    cultivos:['ARANDANO','UVA','ESPARRAGO'],
    transportes:['TERRESTRE','MARITIMO','AEREO'],
    semanas:['TODOS',numeroSemanaActual,numeroSemanaActual+1,numeroSemanaActual+2],
    respuestaErrores:[],
    mostrarErrores:false,

    // cultivos_search:[
    //   'TODOS','ARANDANO','UVA','ESPARRAGO'
    // ],

    detalle_des_productos:[],
    tipo_doc:'Factura',
    filterOn: [],
    fields: [
      {
        key: 'acciones',
        label: '#',
        thClass: 'text-center py-0 alinear-medioA',
        class: 'px-1 text-center',
      },
      {
        key: 'semana',
        label: 'semana',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'transporte',
        label: 'transporte',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'incoterm',
        label: 'incoterm',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'cultivo',
        label: 'cultivo',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
      },
      {
        key: 'cod_cliente',
        label: 'cod_cliente',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'cliente',
        label: 'cliente',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'pack_style',
        label: 'pack_style',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'variedad', // Aqui va si es UK o UE
        label: 'variedad',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'calibre',
        label: 'calibre',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
      },
      {
        key: 'precio',
        label: 'precio',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
      },
      {
        key: 'referencia',
        label: 'referencia',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
      },
      {
        key: 'puerto_destino',
        label: 'puerto_destino',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
      },
      {
        key: 'estado',
        label: 'estado',
        sortable: true,
        tdClass: 'alinear-una-sola-linea text-center',
      },

    ],

    // items: [
    //     {
    //       wk: 35,
    //       customer: "WALMART INC.",
    //       pack_style: 'ARA-1PINTA PICK',
    //       variety: '--',
    //       ref: 'BB-1437',
    //       pdv: '11286',
    //       pbo: '201133',
    //       price_box: '$20.94',
    //     },
    //     {
    //       wk: 35,
    //       customer: "WDRISCOLL´S INC.",
    //       pack_style: 'ARA-1PINTA DRIS',
    //       variety: '--',
    //       ref: 'BB-1437',
    //       pdv: '11286',
    //       pbo: '201144',
    //       price_box: '$20.94',
    //     },
    //   ],



    estados:[
      {value:'1',text:'Activo'},
      {value:'0',text:'Inactivo'}
    ],

    fotosFirma: "",
    estadoModalFirma:false,
    infoModal: {
      title: '',
      boton: '',
    },

    loadingEditar: false,
    estadoModalEditar: false,
    estadoModalImportar:false,
    archivo_excel: null,
    loadingIMP: false,
    id_editar: 0,
    id_evaluador: 0,
    dni: null,
    nombres: null,
    cargo: null,
    packing: null,
    area: null,
    labor: null,
    codigo: null,
    valor_unitario1:'',
    valor_unitario2:'',
    valor_unitario3:'',
    valor_unitario4:'',
    valor_unitario5:'',
    valor_unitario6:'',
    observacion: null,
    estado: null,

    labels: {
      labelPrevDecade: 'Década anterior',
      labelPrevYear: 'Año anterior',
      labelPrevMonth: 'Mes anterior',
      labelCurrentMonth: 'Mes actual',
      labelNextMonth: 'Mes siguiente',
      labelNextYear: 'Año siguiente',
      labelNextDecade: 'Década siguiente',
      labelToday: 'Hoy',
      labelSelected: 'Fecha seleccionada',
      labelNoDateSelected: 'Seleccione fecha',
      labelCalendar: 'Calendario',
      labelNav: 'Navegación por calendario',
      labelHelp: 'Use las teclas de flecha para navegar por el calendario',
      labelTodayButton: 'Hoy',
      labelResetButton: 'Borrar',
      labelCloseButton: 'Cerrar',
    },

    // validation rules
    required,
  }),
  computed: {


  },
  mounted() {
    this.traerPreciosComercial();
    localize("es");
  },

  methods: {

    traerPreciosComercial(){
      console.log("Obteniendo Precios Comercial")
      const yo = this
      yo.loading=true
      const config = {
        method: 'get',
        url: '/comex/holdco/precios_comercial/'
      }

      axiosIns(config)
        .then(function(response) {
          if(response.status==200){
            yo.items = response.data;
            // console.log(yo.items)

            for (let i = 0; i < yo.items.length; i++) {
              if (yo.items[i].estado==='1'){
                yo.items[i].estado='Activo'
              }
            }



            yo.totalRows = yo.items.length
            console.log(response.data)
          }

        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function (){
          yo.loading = false
        })

    },

    actualizarTabla(){
      const yo =  this
      // console.log("ENVIANDO DATOS AL BACKEND")

      if (yo.cultivos_mostrar.length>0){
        // console.log("ESTA LLENO")
        yo.loading=true
        const valores_sele= yo.cultivos_mostrar

        const data={
          'cultivos':valores_sele
        }

        const config= {
          method:'post',
          url:'comex/holdco/precios_comercial_por_cultivo/',
          headers: {
            'Content-Type': 'application/json'
          },
          data:data
        }

        axiosIns(config)
          .then(function(response) {
            if(response.status==200){
              yo.items = response.data['data'];
              yo.totalRows = yo.items.length

              for (let i = 0; i < yo.items.length; i++) {
                if (yo.items[i].estado==='1'){
                  yo.items[i].estado='Activo'
                }
              }

              // console.log(response.data['data'])
            }

          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
          })
      }
      else{
        // console.log("ESTA VACIO")
        yo.traerPreciosComercial()
      }



    },

    mostrarModalImportar(valor){
      const yo = this
      if (valor === true){
        yo.estadoModalImportar = true
      }
    },

    importarOk(bvModalEvtImp) {
      // Prevent modal from closing
      bvModalEvtImp.preventDefault()
      // Trigger submit handler
      this.enviarFile()
    },

    enviarFile(){
      const yo = this
      this.$refs.formularioImportar.validate().then(success => {
        if (success) {
          this.loadingIMP = true
          const data = new FormData();
          data.append('file', yo.archivo_excel)
          data.append('con_usuario', yo.id_user)

          const config = {
            method: 'post',
            url: '/comex/holdco/precios_comercial/importacion_excel/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: data
          }

          axiosIns(config)
              .then(function (response) {
                // console.log(response)
                if(response.status === 200){
                  if (response.data['errores']!=''){
                    yo.respuestaErrores=response.data['errores']
                    yo.mostrarErrores=true
                  }else{
                    yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "La importación se realizó correctamente", 'success', 5000)
                  }
                }
              })
              .catch(function (error) {
                console.log(error);

                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Error en el registro',
                    icon: 'XIcon',
                    text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                    variant: 'danger',
                  },
                })
              })
              .finally(function () {
                yo.traerPreciosComercial();
                yo.archivo_excel = null
                yo.loadingIMP = false
                yo.$nextTick(() => {
                  yo.$refs['modal-importar'].toggle('#toggle-btn')
                })

                // yo.estadoModalRespuesta = true
              })
        }
      })
    },

    mostrarNuevo(){
      this.mostrarModalNuevo=true
    },

    nuevoRegistro(){
      const yo = this

      const data= JSON.stringify({
        'semana': yo.semana_n,
        'transporte':yo.transporte_n,
        'incoterm':yo.incoterm_n,
        'cultivo': yo.cultivo_n,
        'cod_cliente':yo.cod_cliente_n,
        'cliente': yo.cliente_n,
        'pack_style': yo.pack_style_n,
        'variedad': yo.variedad_n,
        'calibre':yo.calibre_n,
        'precio': yo.precio_n,
        'referencia': yo.referencia_n,
        'puerto_destino':yo.puerto_destino_n,
        'id_usuario':id_usuario,
      })

      const config= {
        method:'POST',
        url:'comex/holdco/precios_comercial/nuevo/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      }

      axiosIns(config)
        .then(function(response) {
          if (response.status==200){
            if(response.data['error']){
              yo.mostrarNotificacion('Error en el registro','XIcon','Ya existe un registro en esta semana con esos datos', 'danger', 5000)
            }else{
              yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se hizo correctamente", 'success', 5000)
              yo.resetModal();
            }
            yo.mostrarModalNuevo=false
            yo.traerPreciosComercial();
          }
        })

    },

    editarRegistro(){
      const yo = this
      yo.loadingEditar = false

      if (yo.cultivo=='UVA' || yo.cultivo=='ARANDANO'){
        yo.calibre=''
      }
      else if (yo.cultivo=='ESPARRAGO'){
        yo.variedad=''
      }



      const data = JSON.stringify({
        'id':yo.id,
        'semana': yo.semana,
        'transporte': yo.transporte,
        'incoterm': yo.incoterm,
        'cultivo': yo.cultivo,
        'cod_cliente': yo.cod_cliente,
        'cliente': yo.cliente,
        'pack_style': yo.pack_style,
        'variedad': yo.variedad,
        'calibre':yo.calibre,
        'precio':yo.precio,
        'estado':yo.estadoSelected,
        'referencia':yo.referencia,
        'puerto_destino':yo.puerto_destino
      })

      const config = {
        method: 'post',
        url: '/comex/holdco/precios_comercial/editar/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      }


      axiosIns(config)
          .then(function (response) {
            if (response.status === 200){
              yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se editó correctamente", 'success', 5000)
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('Error en la edición', 'BellIcon', 'Error: \n '+error.toString(), 'danger', 5000)
          })
          .finally(function (){
            yo.traerPreciosComercial()

            yo.$nextTick(() => {
              yo.$refs['modal-editar'].toggle('#toggle-btn')
            })
            yo.loadingEditar = false
          })



    },

    // generarPdf(datos){
    //   const yo=this
    //   var datosg_factura=[];
    //   datosg_factura=datos
    //   const n_factura=datos['num_doc_referencia']
    //   const cliente=datos['customer']
    //   const referencia=datos['ref_contenedor']

    //   const nombre_archivo='HOLDCO '+n_factura.toString()+' '+cliente.toString()+ ' '+ referencia.toString()
    //   console.log(nombre_archivo)
    //   console.log(datos)
    //   const data=JSON.stringify(
    //     {
    //       'datosg_factura':datosg_factura,
    //       // 'rango_fecha':yo.dateRange
    //     }
    //   )

    //   const config={
    //     method:'post',
    //     url:'/holdco/facturas/pdf/',
    //     headers: {
    //         'Content-Type': 'application/json'
    //       },
    //       responseType: 'arraybuffer',
    //       data : data
    //   }

    //   axiosIns(config)
    //     .then(function(response){
    //       if(response.status===200){
    //         console.log("RSPTA GOOD")
    //         var pdf_url = URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
    //         // window.open(pdf_url);
    //         const link = document.createElement('a');
    //         link.href = pdf_url;
    //         link.setAttribute('download', nombre_archivo+'.pdf');
    //         document.body.appendChild(link);
    //         link.click();
    //       }
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     })
    //     .finally(function () {
    //       yo.loadingExcel = false
    //     });

    // },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    abrirModalEditar(datos){
      // this.detalle_des_productos=[];

      // console.log(datos['estado'])

      this.mostrarModalEditar = true
      this.id=datos['id']
      this.semana=datos['semana']
      this.transporte=datos['transporte']
      this.incoterm=datos['incoterm']
      this.cultivo=datos['cultivo']
      this.cod_cliente=datos['cod_cliente']
      this.cliente=datos['cliente']
      this.pack_style=datos['pack_style']
      this.referencia=datos['referencia']
      this.puerto_destino=datos['puerto_destino']

      this.variedad=datos['variedad']
      this.calibre=datos['calibre']

      this.precio=datos['precio']

      this.estadoSelected=datos['estado']

      // console.log(this.estado)
    },

    okModalEditar(bvModalEvt){
      bvModalEvt.preventDefault()

      this.editarRegistro()
    },


    okModalNuevo(bvModalEvt){
      bvModalEvt.preventDefault()

      this.nuevoRegistro()

    },

    // -.-.-.-.-.-.-.-.-..-.-.-

    resetModal() {
      const yo=this
      this.id_editar = null

      yo.semana_n=null
      yo.transporte_n=null
      yo.incoterm_n=null
      yo.cultivo_n=null
      yo.cod_cliente_n=null
      yo.cliente_n=null
      yo.pack_style_n=null
      yo.puerto_destino_n=null
      yo.precio_n=null
      yo.variedad_n=null
      yo.calibre_n=null


      // if( yo.calibre_n!=''){
      //   console.log("ESTA VACIO CALIBRE")
      // }
      // else if(yo.variedad_n!=''){
      //   console.log("ESTA VACIO LA VARIEDAD")
      // }

    },

    validacionEditar(bvModalEvt){
      bvModalEvt.preventDefault()
      this.editarEstado()
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: tiempo,
            position: 'top-center',
          })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.alinear-una-sola-linea{
  white-space: nowrap!important;
}

.tablita{
  min-height: 58vh!important;
}

.tablita::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}
.tablita::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}
.tablita::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}

</style>
